import { $, $doc } from './_utils';

let previewTimeout;
let previewCurrentUrl = false;

function checkImage(url, success) {
  const img = new Image();
  let loaded = false;

  // Run only once, when `loaded` is false. If `success` is a
  // function, it is called with `img` as the context.
  img.onload = function () {
    if (loaded) {
      return;
    }

    loaded = true;

    if (success && success.call) {
      success.call(img);
    }
  };

  img.src = url;

  // If the image is already complete (i.e. cached), trigger the
  // `onload` callback.
  if (img.complete) {
    img.onload.call(img);
  }
}

function getImageLoading(width, height) {
  let placeholder = `<svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="${width}" height="${height}" fill="#2D2D2D"/></svg>`;

  placeholder = placeholder.replace(/</gi, '%3c');
  placeholder = placeholder.replace(/>/gi, '%3e');
  placeholder = placeholder.replace(/#/gi, '%23');

  return `data:image/svg+xml;utf8,${placeholder}`;
}

// Preview.
$doc.on(
  'mouseenter',
  '.wp-site-blocks > header .vpth-navigation-submenu-features .vpth-navigation-link[data-image]',
  function () {
    const $link = $(this);
    const $preview = $('.wp-site-blocks > header .vpth-navigation-preview-content');
    const $previewOld = $preview.children('.vpth-navigation-preview-old');
    const $previewNew = $preview.children('.vpth-navigation-preview-new');
    let $previewNewImg = $previewNew.children('img');

    const newTitle = $link.text();
    const newDescription = $link.attr('data-description');
    const newImage = $link.attr('data-image');
    const newImageWidth = $link.attr('data-image-width');
    const newImageHeight = $link.attr('data-image-height');

    // Create preview elements.
    if (!$previewNewImg.length) {
      const image = document.createElement('img');
      const title = document.createElement('div');
      const description = document.createElement('p');

      image.setAttribute('src', getImageLoading(newImageWidth, newImageHeight));
      image.setAttribute('width', newImageWidth);
      image.setAttribute('height', newImageHeight);
      image.setAttribute('decoding', 'auto');
      image.setAttribute('alt', '');

      title.classList.add('vpth-navigation-preview-title');
      title.innerHTML = newTitle;

      description.innerHTML = newDescription;

      $previewNew.append(image);
      $previewNew.append(title);
      $previewNew.append(description);

      $previewNewImg = $previewNew.children('img');
    }

    if ($previewOld.children('.vpth-navigation-preview-title').text() === newTitle) {
      return;
    }

    clearTimeout(previewTimeout);

    previewCurrentUrl = newImage;

    $preview.addClass('replacing');

    // Replace image.
    $previewNewImg.attr({
      src: getImageLoading(newImageWidth, newImageHeight),
      width: newImageWidth,
      height: newImageHeight,
    });

    checkImage(newImage, () => {
      if (previewCurrentUrl && previewCurrentUrl === newImage) {
        previewCurrentUrl = false;

        $previewNewImg.attr('src', newImage);
      }
    });

    // Replace title.
    $previewNew.children('.vpth-navigation-preview-title').html(newTitle);

    // Replace description.
    $previewNew.children('p').html(newDescription);

    previewTimeout = setTimeout(() => {
      $preview.removeClass('replacing');

      $previewNew
        .removeClass('vpth-navigation-preview-new')
        .addClass('vpth-navigation-preview-old');
      $previewOld
        .removeClass('vpth-navigation-preview-old')
        .addClass('vpth-navigation-preview-new');
    }, 150);
  }
);

// Toggle show the submenu with focus.
function toggleShow() {
  const $item = $(this).parents('.vpth-navigation-item.has-child');
  const $submenu = $item.children('.vpth-navigation-submenu');

  $item.toggleClass('focus');
  $submenu.toggleClass('focus');
}

$doc.on('focus blur', '.vpth-navigation-top .vpth-navigation-link', toggleShow);
